import { Deserializable } from './deserializable';

export class AuthUserModel implements Deserializable {

  id: number = null;
  firstname: string = null;
  lastname: string = null;
  email: string = null;
  type: string = null;
  subtype: string = null;
  roles: Array<string> = [];
  hashed_id: string; // tslint:disable-line: variable-name

  deserialize(input: any): this {
    return Object.assign(this, input);
  }

  get fullname(): string {
    return this.firstname + ' ' + this.lastname;
  }

  get highest_role(): string {
    if (this.roles.length > 0) {
      return this.roles[0];
    } else {
      return '';
    }
  }

}
